function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_ADMIN = '/admin';

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
  newPassword: path(ROOTS_AUTH, '/new-password')
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    report: path(ROOTS_DASHBOARD, '/user/report')
  },
  explore: {
    root: path(ROOTS_DASHBOARD, '/explore'),
    following: path(ROOTS_DASHBOARD, '/explore/following'),
    followingView: path(ROOTS_DASHBOARD, '/explore/followed'),
    pathway: path(ROOTS_DASHBOARD, '/explore/pathways/:title'),
    pathways: path(ROOTS_DASHBOARD, '/explore/pathways'),
    sharedWithYou: path(ROOTS_DASHBOARD, '/explore/sharedwithyou'),
    suggestions: path(ROOTS_DASHBOARD, '/explore/suggestions'),
    shared: path(ROOTS_DASHBOARD, '/explore/shared')
  },
  pathway: {
    new: path(ROOTS_DASHBOARD, '/pathway/new'),
    edit: path(ROOTS_DASHBOARD, '/pathway/edit/:pathwayId'),
    path: path(ROOTS_DASHBOARD, '/pathway')
  },
  pathways: {
    view: path(ROOTS_DASHBOARD, '/pathways/view')
  },
  topic: {
    view: path(ROOTS_DASHBOARD, '/topic/:pathwaySlug/:topicGuid/view')
  },
  overview: {
    root: path(ROOTS_DASHBOARD, '/overview')
  },
  upNext: {
    root: path(ROOTS_DASHBOARD, '/up-next')
  },
  circle: {
    root: path(ROOTS_DASHBOARD, '/circle'),
    details: path(ROOTS_DASHBOARD, '/circle/:circleId'),
    create: path(ROOTS_DASHBOARD, '/circle/create'),
    activity: path(ROOTS_DASHBOARD, '/circle/activity'),
    aiContent: path(ROOTS_DASHBOARD, '/circle/:circleId/ai-content')
  },
  externalPlatforms: {
    root: path(ROOTS_DASHBOARD, '/external-platforms')
  },
  flashcards: {
    root: path(ROOTS_DASHBOARD, '/flashcards')
  },
  notifications: {
    root: path(ROOTS_DASHBOARD, '/notifications')
  }
};

export const PATH_ADMIN = {
  root: ROOTS_ADMIN,
  analytics: path(ROOTS_ADMIN, '/analytics'),
  learningCycles: path(ROOTS_ADMIN, '/learning-cycles'),
  topicMigration: path(ROOTS_ADMIN, '/topic-migration'),
  resourceMigration: path(ROOTS_ADMIN, '/resource-migration'),
  organizations: path(ROOTS_ADMIN, '/organizations')
};

const ROOTS_RESEARCH = '/research';

export const PATH_RESEARCH = {
  root: ROOTS_RESEARCH,
  overview: path(ROOTS_RESEARCH, '/overview')
};

const ROOTS_ORG = '/organization';

export const PATH_ORG = {
  root: ROOTS_ORG,
  overview: path(ROOTS_ORG, '/overview'),
  members: path(ROOTS_ORG, '/members'),
  circles: path(ROOTS_ORG, '/circles'),
  circlesCreate: path(ROOTS_ORG, '/circles/create'),
  pathways: path(ROOTS_ORG, '/pathways'),
  pathwaysCreate: path(ROOTS_ORG, '/pathways/create')
};
